/* eslint-disable no-console */
// import * as SecureStore from "expo-secure-store";

// Storage keys
const accessToken = "accessToken";
const refreshToken = "refreshToken";
const retailerName = "retailerName";
const pointOfSaleId = "pointOfSaleId";
const userId = "userId";
const languageCode = "languageCode";
const emailAddress = "emailAddress";
const password = "password";
const cameraCode = "cameraCode";
const colorMode = "colorMode";
const orderDrawer = "orderPortalDrawer";
const transactionsDrawer = "transactionsDrawer";
const cardbaseV4Drawer = "cardbaseV4Drawer";
const cardNumberSearchHistory = "cardNumberSearchHistory";
const balanceCheckerEditorSettings = "balanceCheckerEditorSettings";
const balanceCheckerEditorCode = "balanceCheckerEditorCode";
const cardNumberPrefix = "cardNumberPrefix";

// store to respective storage, do not use these in the code
export const setToStore = (key, value) => {
  const setToSecureStore = async (secureStoreKey, secureStoreValue) => {
    if (process.env.REACT_APP_PLATFORM === "mobile") {
      const SecureStore = require("expo-secure-store"); // eslint-disable-line global-require
      await SecureStore.setItemAsync(secureStoreKey, secureStoreValue, {
        requireAuthentication: false,
      });
    }
  };

  switch (process.env.REACT_APP_PLATFORM) {
    case "mobile":
      setToSecureStore(key, value);
      break;

    case "web":
      if (typeof window !== "undefined" && window.localStorage)
        window.localStorage.setItem(key, value);
      break;

    default:
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.setItem(key, value);
      }
  }
};

export const getFromStore = (key) => {
  const getFromSecureStore = async (secureStoreKey) => {
    if (process.env.REACT_APP_PLATFORM === "mobile") {
      const SecureStore = require("expo-secure-store"); // eslint-disable-line global-require
      const value = await SecureStore.getItemAsync(secureStoreKey);

      return value;
    }
    return undefined;
  };
  switch (process.env.REACT_APP_PLATFORM) {
    case "mobile":
      return getFromSecureStore(key);

    case "web":
      if (typeof window !== "undefined" && window.localStorage)
        return window.localStorage.getItem(key);

      return undefined;

    default:
      if (typeof window !== "undefined" && window.localStorage) {
        return window.localStorage.getItem(key);
      }

      return undefined;
  }
};

export const getFromMobile = async (key) => {
  const getFromSecureStore = async (secureStoreKey) => {
    if (process.env.REACT_APP_PLATFORM === "mobile") {
      const SecureStore = require("expo-secure-store"); // eslint-disable-line global-require
      const value = await SecureStore.getItemAsync(secureStoreKey);
      return value;
    }
    return undefined;
  };

  if (process.env.REACT_APP_PLATFORM === "mobile") {
    return getFromSecureStore(key);
  }
  return [];
};

// Use wrapper const in code instead
export const setAccessTokenToStorage = (value) => {
  setToStore(accessToken, value);
};

export const getAccessTokenFromStorage = () => {
  return getFromStore(accessToken);
};

export const setRefreshTokenToStorage = (value) => {
  setToStore(refreshToken, value);
};

export const getRefreshTokenFromStorage = () => {
  return getFromStore(refreshToken);
};

export const getRetailerNameFromStorage = () => {
  return getFromStore(retailerName);
};

export const setRetailerNameToStorage = (value) => {
  setToStore(retailerName, value);
};

export const getPointOfSaleIdFromStorage = () => {
  return getFromStore(pointOfSaleId);
};

export const setPointOfSaleIdToStorage = (value) => {
  setToStore(pointOfSaleId, value);
};

export const getUserIdFromStorage = () => {
  return getFromStore(userId);
};

export const setUserIdToStorage = (value) => {
  setToStore(userId, value);
};

export const getLanguageCodeFromStorage = () => {
  return getFromStore(languageCode);
};

export const setLanguageCodeToStorage = (value) => {
  setToStore(languageCode, value);
};
export const getCameraCodeFromStorage = () => {
  return getFromStore(cameraCode);
};

export const setCameraCodeToStorage = (value) => {
  setToStore(cameraCode, value);
};

export const getPasswordFromStorage = () => {
  return getFromStore(password);
};

export const setPasswordToStorage = (value) => {
  setToStore(password, value);
};

export const getEmailFromStorage = () => {
  return getFromStore(emailAddress);
};

export const setEmailToStorage = (value) => {
  setToStore(emailAddress, value);
};

export const getColorMode = () => {
  return getFromStore(colorMode);
};

export const setColorMode = (value) => {
  setToStore(colorMode, value);
};

export const getOrderDrawer = () => {
  return getFromStore(orderDrawer);
};

export const setOrderDrawer = (value) => {
  setToStore(orderDrawer, value);
};

export const getCardbaseV4Drawer = () => {
  return getFromStore(cardbaseV4Drawer);
};

export const setCardbaseV4Drawer = (value) => {
  setToStore(cardbaseV4Drawer, value);
};

export const getTransactionsDrawer = () => {
  return getFromStore(transactionsDrawer);
};

export const setTransactionsDrawer = (value) => {
  setToStore(transactionsDrawer, value);
};

export const getBalanceCheckerEditorSettings = () => {
  return JSON.parse(getFromStore(balanceCheckerEditorSettings)) || {};
};

export const setBalanceCheckerEditorSettings = (settings) => {
  setToStore(balanceCheckerEditorSettings, JSON.stringify(settings || {}));
};

export const getBalanceCheckerEditorCode = () => {
  return getFromStore(balanceCheckerEditorCode);
};

export const setBalanceCheckerEditorCode = (code) => {
  setToStore(balanceCheckerEditorCode, code);
};

export const setCardNumberPrefix = (prefix) => {
  setToStore(cardNumberPrefix, prefix);
};

export const getCardNumberPrefix = () => {
  return getFromStore(cardNumberPrefix);
};

export const clearCardNumberPrefix = () => {
  setToStore(cardNumberPrefix, "");
};

const getMostRecentTransactions = async () => {
  if (process.env.REACT_APP_PLATFORM === "mobile") {
    return await getFromMobile(cardNumberSearchHistory);
  }
  return await getFromStore(cardNumberSearchHistory);
};

export const setMostRecentTransactions = (value) => {
  setToStore(cardNumberSearchHistory, value);
};

export const clearMostRecentTransaction = () => {
  const SecureStore = require("expo-secure-store"); // eslint-disable-line global-require
  SecureStore.deleteItemAsync(cardNumberSearchHistory);
};

const parseTransactions = async (mostRecentTransactions, ui = null) => {
  if (mostRecentTransactions) {
    return ui
      ? JSON.parse(mostRecentTransactions).filter(
          (transaction) => transaction.user === ui
        )
      : JSON.parse(mostRecentTransactions);
  }
  return [];
};

export const getMostRecentTransactionsUser = async (ui) => {
  const transactions = await getMostRecentTransactions();
  return parseTransactions(transactions, ui);
};

const addTransaction = (transactions, newTransaction) => {
  const MAXIMUM_SEARCH_HISTORY_LENGTH = 5;
  let addTransactionToStorage = true;
  let indexToRemove = -1;
  transactions.forEach((transaction, index) => {
    if (transaction.cardNumber === newTransaction.cardNumber) {
      // Skip adding of transaction if the new entry is a search and the current entry is not.
      if (
        newTransaction.transactionType === "search" &&
        transaction.transactionType !== "search"
      ) {
        addTransactionToStorage = false;
      } else {
        indexToRemove = index;
      }
    }
  });

  if (addTransactionToStorage) {
    if (indexToRemove > -1) {
      transactions.splice(indexToRemove, 1);
    }

    // Add the new transaction to the front.
    transactions.unshift(newTransaction);
  }
  return transactions.slice(0, MAXIMUM_SEARCH_HISTORY_LENGTH);
};

export const AddMostRecentTransaction = async (
  cardNumber,
  transactionType,
  transactionDate,
  user,
  amount = null,
  currency = null
) => {
  const transactions = await getMostRecentTransactions(); // JSON object

  const userTransactions = await parseTransactions(transactions, user); // array user transactions
  let allTransactions = await parseTransactions(transactions); // array transactions

  // Remove all user transactions
  allTransactions = allTransactions.filter((transaction) => {
    return transaction.user !== user;
  });

  // Add new transaction to user transactions
  const userTransactionsNew = addTransaction(userTransactions, {
    cardNumber,
    transactionType,
    date: transactionDate,
    transactionAmount: amount,
    currency,
    user,
  });

  // Save the new transactions in storage
  setMostRecentTransactions(
    JSON.stringify(allTransactions.concat(userTransactionsNew))
  );
};

export const clearMostRecentTransactionUser = async (user) => {
  const mostRecentTransactions = await getMostRecentTransactions(); // JSON object
  let allMostRecentTransactions = await parseTransactions(
    mostRecentTransactions
  ); // array transactions

  // Remove all user transactions
  allMostRecentTransactions = allMostRecentTransactions.filter(
    (transaction) => {
      return transaction.user !== user;
    }
  );

  // Save the remaining transactions in storage
  setMostRecentTransactions(JSON.stringify(allMostRecentTransactions));
};
